const PurchaseInventoryAPI =  {
    POSTPURCHASE: `purchaseInventory/`,
    GETPURCHASE: `purchaseInventory/purchasedetails`,
    DELETEPURCHASE:`purchaseInventory/66991040af6644fe10bf4860`,
}

export default PurchaseInventoryAPI;